import * as Repositories from '../../repositories/repositories';
import * as Model from '../../models/models';
import {RatingFactorsViewModel} from './ratingFactors.viewmodel';
import { UserRequest } from '../../models/userrequest.model';

export class RatingFactorsGateway {

    public static $inject = [
        '$q',
        'submissionRepository',
        'userRepository',
        'phoneRepository',
        'policyholderRepository',
        'codeRepository'
    ];

    constructor(private $q: ng.IQService,
                private submissionRepository: Repositories.SubmissionRepository,
                private userRepository: Repositories.UserRepository,
                private phoneRepository: Repositories.PhoneRepository,
                private policyholderRepository: Repositories.PolicyholderRepository,
    private codeRepository: Repositories.CodeRepository
    ) {
    }

    public loadRatingFactorsViewModel(submissionId: string): angular.IPromise<RatingFactorsViewModel> {

        const viewModel = new RatingFactorsViewModel();

        return this.$q.all([
            this.userRepository.getSubmissionPrimaryContact(submissionId).then((user: Model.IUserProfile) => viewModel.primaryContact = user),
            this.phoneRepository.getPhoneNumber(submissionId).then((phone: Model.IPhone) => viewModel.phone = phone),
            this.submissionRepository.getById(submissionId).then((submission: Model.ISubmission) => viewModel.submission = submission),
            this.getCodeTables(viewModel)
        ]).then(() => {
            return this.policyholderRepository.getById(viewModel.submission.policyholderId)
                .then((Policyholder: Model.Policyholder) => {
                    viewModel.policyholder = Policyholder;
                    return viewModel;
                });
        });
    }

    public saveRatingFactors(viewModel: RatingFactorsViewModel): ng.IPromise<RatingFactorsViewModel> {
        const result = new RatingFactorsViewModel();
        viewModel.phone.userId = viewModel.primaryContact.id;
        viewModel.policyholder.name = viewModel.submission.legalBusinessName;

        const userRequest = new UserRequest(); 
        userRequest.firstName = viewModel.primaryContact.firstName;
        userRequest.lastName = viewModel.primaryContact.lastName;

        if(viewModel.primaryContact) {
            this.$q.all([
                this.userRepository.updateById(viewModel.primaryContact.id, userRequest).then((user: Model.IUserProfile) => result.primaryContact = user),
                this.phoneRepository.put(viewModel.phone).then((phone: Model.IPhone) => result.phone = phone),
            ]);
        }

        return this.$q.all([
            this.submissionRepository.put(viewModel.submission).then((submission: Model.ISubmission) => result.submission = submission),
            this.policyholderRepository.put(viewModel.policyholder).then((policyholder: Model.IPolicyholder) => result.policyholder = policyholder),
        ]).then(() => this.$q.when(result));
    }
    
    private getCodeTables(viewModel: RatingFactorsViewModel): ng.IPromise<RatingFactorsViewModel> {
        return this.codeRepository.getCodesByCodeType([
                Model.Constants.SubmissionStatus.CodeTypeId.toString()
            ])
            .then((codeTables: Model.ICodeDictionary) => {
                viewModel.submissionStatuses = codeTables[Model.Constants.SubmissionStatus.CodeTypeId.toString()];
                return viewModel;
            });
    }
}